/** Limits scenic vegetation footprint without stripping environment detail.
 * Combat silhouettes occupy the centre; oversized source meshes are fitted
 * by BOTH their vertical and horizontal spans, never by height alone.
 */
export type ScenicZone='horizon'|'far'|'mid'|'near'|'foreground'|'dressing'
const PLANT_MAX_SPAN:Record<ScenicZone,number>={
 horizon:8,far:4.6,mid:2.7,near:2.0,foreground:2.2,dressing:2.55,
}
export function scenicAssetFitScale(
 asset:string,zone:ScenicZone,targetHeight:number,
 bounds:{x:number;y:number;z:number},
):number{
 const heightScale=Math.max(.05,targetHeight)/Math.max(.001,bounds.y)
 if(asset!=='crystalPlant')return heightScale
 const horizontalScale=PLANT_MAX_SPAN[zone]/Math.max(.001,bounds.x,bounds.z)
 return Math.min(heightScale,horizontalScale)
}
